if (!customElements.get('announcement-countdown')) {
  class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.timeEl = this.querySelector('[data-countdown-time]');

      if (this._countdownInterval) {
        clearInterval(this._countdownInterval);
        this._countdownInterval = null;
      }

      this.tick();

      this.timer = setInterval(() => {
        this.tick();
      }, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this._countdownInterval) {
        clearInterval(this._countdownInterval);
      }
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }

    remainingSeconds() {
      const DAY = 86400;
      const cycleEnd = Number(this.dataset.cycleEnd);

      if (!cycleEnd) {
        const now = new Date();
        const nextMidnight = new Date(now);
        nextMidnight.setHours(24, 0, 0, 0);
        const remaining = Math.floor((nextMidnight.getTime() - now.getTime()) / 1000);
        return remaining <= 0 ? DAY : remaining;
      }

      let remaining = cycleEnd - Math.floor(Date.now() / 1000);
      remaining = ((remaining % DAY) + DAY) % DAY;
      return remaining === 0 ? DAY : remaining;
    }

    tick() {
      if (!this.timeEl) return;

      const remaining = this.remainingSeconds();
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;

      this.timeEl.textContent =
        `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
    }
  }

  customElements.define(
    'announcement-countdown',
    AnnouncementCountdown
  );
}
